import React from "react";
import { Stepper as MuiStepper, Step, StepLabel} from "@mui/material";
import type { StepperProps } from "./types/types";
import { CustomStepConnector, CustomSubStepConnector } from "./stepper.constants";
import StepperIcon from "./components/StepperIcon";

const Stepper: React.FC<StepperProps> = ({ 
  steps, 
  activeStep, 
  variant = 'main',
  className = ''
}) => {
  const stepperClass = variant === 'sub' ? 'sub-stepper' : '';
  const ConnectorComponent = variant === 'sub' ? CustomSubStepConnector : CustomStepConnector;
  
  return (
    <MuiStepper
      alternativeLabel
      activeStep={activeStep}
      connector={<ConnectorComponent />}
      className={className}
    >
      {steps.map((step, idx) => (
        <Step key={step.label} completed={activeStep > idx}>
          <StepLabel 
            className={stepperClass}
            StepIconComponent={(props) => (
              <StepperIcon {...props} variant={variant} icon={step.icon} />
            )}
          >
            {step.label}
          </StepLabel>
        </Step>
      ))}
    </MuiStepper>
  );
};

export default Stepper; 